import service from "../services/serviceOrders.service";

export const serviceOrders = {
    namespaced: true,
    state: {
        data: [],
        currentPage: 1,
        lastPage: 1,
        links: [],
        getData: null,
    },
    getters: {
        allData: (state) => state.data,
        pagination: (state) => ({
            currentPage: state.currentPage,
            lastPage: state.lastPage,
        }),
        links: (state) => state.links,
        getData: (state) => state.getData,
    },
    actions: {
        async fetchData({ commit }, params = null) {
            try {
                const response = await service.getAll(params);
                if (response?.data?.data) {
                    commit('SET_DATA', response.data.data);
                    commit('SET_PAGINATION', {
                        currentPage: response.data.current_page || 1,
                        lastPage: response.data.last_page || 1,
                        links: response.data.links || [],
                    });
                } else if (Array.isArray(response?.data)) {
                    commit('SET_DATA', response.data);
                }
            } catch (error) {
                console.error("Error fetching service orders:", error);
                commit('SET_DATA', []);
            }
        },
        async save(context, data) {
            try {
                if (data.id) {
                    return await service.updateData(data.id, data);
                }
                return await service.createData(data);
            } catch (error) {
                console.error("Error save service order:", error);
                throw error;
            }
        },
        async delete({ commit }, id) {
            const response = await service.deleteData(id);
            commit('REMOVE_DATA', id);
            return response;
        },
        async getData({ commit }, id) {
            const response = await service.getData(id);
            commit('SET_GET_DATA', response.data);
            return response;
        },
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
        },
        SET_PAGINATION(state, pagination) {
            state.currentPage = pagination.currentPage;
            state.lastPage = pagination.lastPage;
            state.links = pagination.links;
        },
        SET_GET_DATA(state, data) {
            state.getData = data;
        },
        REMOVE_DATA(state, id) {
            state.data = state.data.filter((item) => item.id !== id);
        },
    },
};
